// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/chart-symbols.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/chart-symbols/chart-symbols.js';

mount([g0]);
